
import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { ArrowBack } from "@mui/icons-material"; // optional icon

import Menuiteams from "./Menuiteams.js";
import SidescrollAdvertisements from '../Landingpages/Profile/SidescrollAdvertisements.js';

const Newmenuiteam = ({ setShowLogin }) => {
  const [activeCategory, setActiveCategory] = useState("Allitems");
  const [parentId, setParentId] = useState(null);
  const [categories, setCategories] = useState([]);
  const [dishes, setDishes] = useState([]);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [isTablet, setIsTablet] = useState(window.innerWidth > 768 && window.innerWidth <= 1024);
  const [bannerData, setBannerData] = useState(null);
  const [isHovered, setIsHovered] = useState(false);
  const navigate = useNavigate();

  const scrollContainerRef = useRef(null);
  const [coupons, setCoupons] = useState([]);

  // Handle screen resize
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      setIsTablet(window.innerWidth > 768 && window.innerWidth <= 1024);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Fetch categories and dishes
  useEffect(() => {
    const vendorId = localStorage.getItem("vendorId");
    if (!vendorId) return;

    const token = localStorage.getItem("authToken"); // ✅ get stored token

    fetch(
      `https://backend.maamaas.com/food/api/dish/getbyvendor/${vendorId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`, // ✅ send token in headers
          Accept: "application/json",
        },
      }
    )
      .then((res) => {
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        return res.json();
      })
      .then((data) => {
        const cats = data.filter(
          (item) => item.parentId === 0 || item.parentId === null
        );
        const dis = data.filter(
          (item) => item.parentId !== 0 && item.parentId !== null
        );
        setCategories(cats);
        setDishes(dis);
      })
      .catch((err) => console.error("❌ Error fetching data:", err));
  }, []);


  // Fetch banner data
  useEffect(() => {
    const vendorId = localStorage.getItem("vendorId");
    if (!vendorId) return;

    const token = localStorage.getItem("authToken"); // ✅ get stored token

    axios
      .get(
        `https://backend.maamaas.com/food/api/banner/${vendorId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`, // ✅ send token in headers
          },
        }
      )
      .then(({ data }) =>
        setBannerData({ ...data, companyName: data.companyName || "No Name" })
      )
      .catch(() => console.error("❌ Could not load banner details."));
  }, []);


  // Handle category click
  const handleClick = (categoryName) => {
    if (categoryName === "Allitems") {
      setParentId(null);
      setActiveCategory("Allitems");
      return;
    }

    const selected = categories.find(
      (cat) =>
        cat.dishName.trim().toLowerCase() ===
        categoryName.trim().toLowerCase()
    );

    if (selected) {
      setParentId(selected.dishId);
      setActiveCategory(categoryName);
    } else {
      setParentId(null);
      setActiveCategory("Allitems");
    }
  };

  // Sample offers
  useEffect(() => {
    // Fetch coupons from API
    axios
      .get(
        "https://backend.maamaas.com/food/api/coupon/vendor/3/active"
      )
      .then((res) => {
        if (res.data) {
          setCoupons(res.data); // assuming API returns array of coupons
        }
      })
      .catch((err) => {
        console.error("Error fetching coupons:", err);
      });
  }, []);

  // ✅ Dummy Coupons (अगर API नहीं है तो ये चलेंगे)
  useEffect(() => {
    setCoupons([
      { code: "PIZZA50", discountPercentage: 50, dishId: 1 },
      { code: "BURGER30", discountPercentage: 30, dishId: 2 },
      { code: "DEL99", discountPercentage: 20, dishId: 3 },
    ]);
  }, []);

  return (
    <>
      <div
        className="container-fluid main-layout"
        style={{
          display: "flex",
          marginTop: "38px",
          height: "calc(100vh - 38px)",
          overflow: "hidden",
        }}>
        {/* Sidebar - Responsive */}
        <div
          className={`sidebar ${isMobile ? 'col-12' : isTablet ? 'col-md-3' : 'col-lg-2 col-md-3'}`}
          style={{
            flexShrink: 0,
            background: "#fff",
            overflow: "hidden", // Keep container hidden
            marginTop: "35px",
            position: "relative",
            height: "auto",
            zIndex: 1,
            padding: "0px 20px",
            display: "flex",
            flexDirection: "column",
          }}>

          {/* Fixed Company Name */}
          {/* <div style={{
            flexShrink: 0, // Don't shrink
            position: "sticky",
            top: 0,
            background: "#fff",
            zIndex: 10,
            padding: "10px 0",
            marginBottom: "10px",
          }}>
            
            <p style={{
              fontWeight: "bold",
              fontSize: isMobile ? "18px" : isTablet ? "20px" : "22px",
              margin: 0,
              textAlign: isMobile ? "center" : "left",
            }}>
              <Link style={{
                color: "rgb(177, 92, 214)",
                textDecoration: "none",
                fontSize: isTablet ? "18px" : "20px"
              }}>
                <h2 style={{
                  fontSize: isTablet ? "1.5rem" : "2rem",
                  margin: "20px 0px 0px 0px",
                  marginBottom: "-20px",
                  textAlign: "center",
                  padding:"20px 10px"
                }}>
                  {bannerData?.companyName || ""}
                </h2>
              </Link>
            </p>
          </div> */}
          <div
            style={{
              flexShrink: 0, // Don't shrink
              position: "sticky",
              top: 0,
              background: "#fff",
              zIndex: 10,
              padding: "10px 0",
              marginBottom: "10px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {/* Back Button */}
            <button
              onClick={() => navigate("/homepage")}
              style={{
                position: "fixed",
                left: "10px",
                background: "none",
                border: "none",
                cursor: "pointer",
                color: "rgb(177, 92, 214)",
                fontSize: isMobile ? "16px" : "18px",
                display: isMobile ? "flex" : "none",
                alignItems: "center",
                gap: "5px",
              }}
            >
              <ArrowBack style={{ fontSize: isMobile ? "20px" : "24px" }} />
              {/* Back */}
            </button>

            {/* Company Name */}
            <p
              style={{
                fontWeight: "bold",
                fontSize: isMobile ? "18px" : isTablet ? "20px" : "22px",
                margin: 0,
                textAlign: "center",
              }}
            >
              <Link
                // to="/homepage"
                style={{
                  color: "rgb(177, 92, 214)",
                  textDecoration: "none",
                  fontSize: isTablet ? "18px" : "20px",
                }}
              >
                <h2
                  style={{
                    fontSize: isTablet ? "1.5rem" : "2rem",
                    margin: "20px 0 0 0",
                    marginBottom: "-20px",
                    textAlign: "center",
                    padding: "20px 10px",
                  }}
                >
                  {bannerData?.companyName || ""}
                </h2>
              </Link>
            </p>
          </div>


          {/* Scrollable Categories Container */}
          <div
            className="hide-scrollbar"
            style={{
              flex: 1, // Take remaining space
              overflowY: "auto",
              overflowX: "hidden",
              paddingBottom: "30px",
              // Add these styles to hide scrollbar
              scrollbarWidth: "none", /* Firefox */
              msOverflowStyle: "none", /* IE and Edge */
            }}>
            {isMobile ? (
              <div style={{ position: "relative", marginBottom: "15px" }}>
                <select
                  onChange={(e) => handleClick(e.target.value)}
                  value={activeCategory}
                  style={{
                    width: "100%",
                    padding: "12px",
                    borderRadius: "10px",
                    background: "rgb(177 93 198)",
                    color: "#fff",
                    fontWeight: "bold",
                    marginTop: "10px",
                    marginBottom: "10px",
                    border: "none",
                    fontSize: "16px",
                    position: "relative",
                  }}
                >
                  <option value="Allitems">All Items</option>
                  {categories.map((cat) => (
                    <option key={cat.dishId} value={cat.dishName}>
                      {cat.dishName}
                    </option>
                  ))}
                </select>
              </div>
            ) : (
              <div
                className="hide-scrollbar"
                style={{
                  marginTop: "0px",
                  overflowY: "visible",
                  overflowX: "hidden",
                  height: "auto",
                  padding: "0px 10px 10px 10px",
                  position: "relative",
                }}>
                <div
                  className="card"
                  onClick={() => handleClick("Allitems")}
                  style={{
                    backgroundColor: activeCategory === "Allitems" ? "rgb(177 93 198)" : "#D9D9D9",
                    marginTop: "10px",
                    width: isTablet ? "160px" : "190px",
                    padding: isTablet ? "12px" : "15px",
                    textAlign: "center",
                    cursor: "pointer",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    borderRadius: "12px",
                    marginLeft: "auto",
                    marginRight: "auto",
                    position: "relative",
                  }}
                >
                  <div style={{
                    background: "rgba(0,0,0,0.3)",
                    color: "#fff",
                    fontWeight: "bold",
                    padding: "6px 12px",
                    borderRadius: "8px",
                    width: "fit-content",
                    fontSize: isTablet ? "14px" : "16px"
                  }}>
                    All
                  </div>
                </div>

                {categories.map((cat) => (
                  <div
                    key={cat.dishId}
                    className="card"
                    onClick={() => handleClick(cat.dishName)}
                    style={{
                      backgroundColor: activeCategory === cat.dishName ? "rgb(177 93 198)" : "#D9D9D9",
                      marginTop: "10px",
                      padding: isTablet ? "12px" : "15px",
                      textAlign: "center",
                      width: isTablet ? "160px" : "190px",
                      cursor: "pointer",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      borderRadius: "12px",
                      marginLeft: "auto",
                      marginRight: "auto",
                      position: "relative",
                    }}
                  >
                    <img
                      src={cat.dishImage}
                      alt={cat.dishName}
                      style={{
                        borderRadius: "50%",
                        width: isTablet ? "80px" : "100px",
                        height: isTablet ? "80px" : "100px",
                        objectFit: "cover",
                        marginBottom: "8px",
                      }}
                    />
                    <div style={{
                      background: "rgba(0,0,0,0.3)",
                      color: "#fff",
                      fontWeight: "bold",
                      padding: "5px 10px",
                      borderRadius: "8px",
                      width: "fit-content",
                      fontSize: isTablet ? "12px" : "14px",
                      textAlign: "center",
                      lineHeight: "1.2"
                    }}>
                      {cat.dishName}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        {/* Main Menu - Scrollable */}
        <div
          className={`main-content ${isMobile ? 'col-12' : isTablet ? 'col-md-6' : 'col-lg-7 col-md-6'}`}
          style={{
            overflowY: "auto",
            padding: isMobile ? "0 10px" : "0 15px",
            marginTop: isMobile ? "10px" : "40px",
            height: isMobile ? "auto" : "100%",
            minHeight: isMobile ? "calc(100vh - 150px)" : "auto"
          }}>

          {/* {isMobile && (
            <p
              style={{
                background: "#fff",
                zIndex: 10,
                padding: "8px 0",
                fontWeight: "bold",
                fontSize: "16px",
                margin: 0,
                textAlign: "center",
                color: "rgb(177, 92, 214)"
              }}
            >
              {bannerData?.companyName || ""}
            </p>
          )} */}

          <Menuiteams parentId={parentId} setShowLogin={setShowLogin} />
        </div>

        {/* Right Offers - Responsive */}
        <div
          className={`right-offers ${isMobile ? 'd-none' : ''}`}
          style={{
            display: isMobile ? "none" : isTablet ? "none" : "block",
            position: "sticky",
            top: "40px",
            height: "calc(100vh - 80px)",
            overflowY: "auto"
          }}
        >
          <SidescrollAdvertisements />
        </div>
      </div >

      {/* Enhanced CSS for responsiveness */}
      < style >
        {`
    * {
    box-sizing: border-box;
  }
  
  .container-fluid {
    padding: 0 !important;
    margin: 0 !important;
    width: 100% !important;
  }

  /* Hide scrollbars but allow scrolling */
  .main-content::-webkit-scrollbar,
  .sidebar::-webkit-scrollbar {
    display: none;
  }
  .main-content,
  .sidebar {
    -ms-overflow-style: none;
    scrollbar-width: none;
  }

  /* Main layout - FIXED */
  .main-layout {
    width: 100% !important;
    margin: 0 !important;
    padding: 0 !important;
    display: flex;
    min-height: 100vh;
    overflow: visible !important;
  }

  /* Mobile */
  @media (max-width: 768px) {
    .main-layout {
      flex-direction: column;
      height: auto;
      margin-top: 20px;
      overflow: visible !important;
    }
    
    .sidebar {
      width: 100% !important;
      margin-top: -10px;
      overflow: visible !important;
      height: auto !important;
    }
    
    .main-content {
      width: 100% !important;
      margin-top: 15px;
      padding: 0 10px;
      overflow: visible !important;
    }
  }

  @media (max-width: 425px) {
    .main-layout {
      flex-direction: column;
      height: auto;
      margin-top: 20px;
      overflow: visible !important;
    }
    
    .sidebar {
      width: 100% !important;
      margin-top: -10px;
      overflow: visible !important;
      height: auto !important;
      padding-bottom: -40px;
    }
    
    .main-content {
      width: 100% !important;
      margin-top: 15px;
      padding: 0 10px;
      overflow: visible !important;
    }
  }

  /* Tablet (769px - 1023px) */
  @media (min-width: 769px) and (max-width: 1023px) {
    .main-layout {
      height: auto;
      min-height: 100vh;
      overflow: visible !important;
    }
    
    .sidebar {
      width: 25% !important;
      flex: 0 0 25% !important;
      margin-top: 10px;
      max-width: 250px;
      position: relative;
      height: auto;
      overflow-y: auto !important;
      overflow-x: hidden;
    }
    
    .main-content {
      width: 75% !important;
      flex: 1 !important;
      margin-top: 30px;
      padding: 0 20px;
      height: auto;
      overflow-y: auto;
    }

    .right-offers {
      width: 20% !important;
      position: relative;
      height: auto;
      overflow-y: auto;
    }
  }

  /* Large Screens (1024px and above) - NO SCROLLING */
  @media (min-width: 1024px) {
    .main-layout {
      height: calc(100vh - 38px) !important; /* FIXED height */
      min-height: auto;
      overflow: hidden !important; /* PREVENT scrolling */
    }
    
    .sidebar {
      width: 25% !important;
      flex: 0 0 25% !important;
      margin-top: 10px;
      max-width: 250px;
      position: relative;
      height: 100% !important; /* FIXED height */
      overflow-y: hidden !important; /* PREVENT scrolling */
      overflow-x: hidden;
    }
    
    .main-content {
      width: 75% !important;
      flex: 1 !important;
      margin-top: 30px;
      padding: 0 20px;
      height: 100% !important; /* FIXED height */
      overflow-y: hidden !important; /* PREVENT scrolling */
    }

    .right-offers {
      width: 20% !important;
      position: relative;
      height: 100% !important; /* FIXED height */
      overflow-y: hidden !important; /* PREVENT scrolling */
    }
  }



  @media(max-width: 1380px) {
    .right-offers{
      display:none !important;
    }
  }
     .hide-scrollbar {
    scrollbar-width: none;      /* Firefox */
    -ms-overflow-style: none;   /* Internet Explorer / Edge */
  }
  .hide-scrollbar::-webkit-scrollbar {
    display: none;              /* Chrome, Safari, Opera */
  }
`}
      </style >
    </>
  );
};

export default Newmenuiteam;